import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Checkbox from "components/library/Checkbox";
import WithPermissions from "components/library/WithPermissions";
import PermissionsSwitch from "components/library/PermissionsSwitch";

import styles from "./TagRow.css";
import permissionsMatch from "utils/permissionsMatch";

export default function TagRow(props) {
  const { tag, permissions } = props;
  const selectablePermissions = ["content.delete_tag", "content.add_tag"];

  return (
    <div
      className={classNames(styles.root, {
        [styles.disabled]: props.disabled,
        [styles.selectable]: permissionsMatch({
          permissions,
          oneOf: selectablePermissions,
        }),
      })}
      onClick={props.onChange}
    >
      <PermissionsSwitch>
        <WithPermissions oneOf={selectablePermissions}>
          <Checkbox
            label={tag.name}
            onChange={props.onChange}
            className={styles.name}
            labelClassName={styles.label}
            isChecked={props.selected}
            isDisabled={props.disabled}
          />
        </WithPermissions>
        <WithPermissions>
          <span className={styles.name}>{tag.name}</span>
        </WithPermissions>
      </PermissionsSwitch>
      <span className={styles.col}>
        {tag.tag_type ? tag.tag_type.name : ""}
      </span>
      <span className={styles.col}>
        {tag.stories} {tag.stories == 1 ? "story" : "stories"}
      </span>
    </div>
  );
}

PropTypes.defaultProps = {
  selected: false,
  permissions: [],
};

TagRow.propTypes = {
  tag: PropTypes.shape({
    name: PropTypes.string.isRequired,
    stories: PropTypes.number,
    tag_type: PropTypes.object,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  permissions: PropTypes.arrayOf(PropTypes.string),
};
